import Iconify from 'src/components/Iconify';
import { MKT } from '../marketing.design';

// Fonte unica de badge de status/ciclo-de-vida na secao Marketing. Antes
// disso o mesmo conceito existia 3x com formas diferentes: statusBadge do
// MktPosts (px-2 py-0.5, chaves gray/blue/amber/green/red), statusBadge do
// MarketingMetricas (px-2.5 py-1, chaves ativa/pausada/finalizada/erro), e um
// ternario de 5 vias inline em MarketingRastreamento (rounded-lg, nao full).
//
// A paleta e compartilhada (TONE); o vocabulario de dominio (o que "ativa"
// ou "published" significa) fica em cada pagina, mapeado para um tone daqui.
export default function StatusChip({ tone = 'neutral', label, icon, dot = true, size = 'base', className = '' }) {
    const chipClass = size === 'sm' ? MKT.chip.sm : MKT.chip.base;
    const toneClass = MKT.tone[tone] ?? MKT.tone.neutral;
    const dotClass = MKT.toneDot[tone] ?? MKT.toneDot.neutral;

    return (
        <span className={`${chipClass} ${toneClass} ${className}`}>
            {icon ? (
                <Iconify icon={icon} width={size === 'sm' ? 11 : 13} />
            ) : (
                dot && <span className={MKT.chip.dot + ' ' + dotClass} />
            )}
            {label}
        </span>
    );
}
